import {
  IValidateFn,
  IFieldValidations,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { FakturaDelQuery_node_TEDLRFakturaDel } from '../Queries/_QueryTypes/FakturaDelQuery';
import {
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRFakturaDelAttestMinaStatusEnum,
  TEDLRLeverantorfakturaMOMSHANTERINGEnum,
} from '../../../../../../globalQueryTypes';
import {
  validateUtlandskChangePreselectedMomssats,
  validateUtlandskDeletePreselectedMomssats,
  validateUtlandskNoPreselectedMomssats,
} from '../Utils/FakturadelValidationUtils';

export const useValidateUtlandskMoms: () => IValidateFn<FakturaDelQuery_node_TEDLRFakturaDel> =
  () => {
    return ({ currentValues, data, touched }) => {
      const errors: IFieldValidations = [];
      const momshantering =
        currentValues?._Associations?.Faktura?.MOMSHANTERING;
      if (
        momshantering == null ||
        momshantering === TEDLRLeverantorfakturaMOMSHANTERINGEnum.EJ_HANTERAT ||
        momshantering ===
          TEDLRLeverantorfakturaMOMSHANTERINGEnum.SVENSK__ENLIGT_KODDEL ||
        momshantering ===
          TEDLRLeverantorfakturaMOMSHANTERINGEnum.SVENSK__ENLIGT_LEVERANTOR
      ) {
        return errors;
      }

      const konteringsforslagArray =
        currentValues?._Associations?.Faktura?._Associations
          ?.Konteringsforslag_All;
      const leverantorMomsmallBenamning =
        currentValues?._Associations?.Faktura?._Associations?.Leverantor
          ?._Associations?.UtlandskMoms?.BENAMNING;
      const leverantorMomsmallId =
        currentValues?._Associations?.Faktura?._Associations?.Leverantor
          ?._Associations?.UtlandskMoms?.id;
      const attestTyp: TEDLRFakturaAttestAttestTypEnum =
        currentValues?.ATTEST_STATUS === 'BESLUTSATTESTERAS'
          ? currentValues?.AttestMinaStatus ===
            TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS
            ? TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
            : TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
          : TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST;

      if (konteringsforslagArray) {
        for (let index = 0; index < konteringsforslagArray.length; index++) {
          const konteringsforslag = konteringsforslagArray[index];

          const hasTouchedUtlandsMomsMall =
            touched?._Associations?.Faktura?._Associations.Konteringsforslag?.[
              konteringsforslag.id
            ]?._Associations.UtlandsMomsMall;

          //Validering på om användaren ändrar tolkad momssats
          const errorChangePreselectedMomssats =
            validateUtlandskChangePreselectedMomssats(
              konteringsforslag.id,
              leverantorMomsmallBenamning,
              konteringsforslag._Associations?.UtlandsMomsMall?.BENAMNING
            );
          if (errorChangePreselectedMomssats) {
            errors.push(errorChangePreselectedMomssats);
          }

          //Validering på om användaren tar bort tolkad momssats
          const errorDeletePreselectedMomssats =
            validateUtlandskDeletePreselectedMomssats(
              konteringsforslag.id,
              konteringsforslag.UTL_MOMS_SATS,
              leverantorMomsmallId,
              attestTyp
            );
          if (errorDeletePreselectedMomssats) {
            errors.push(errorDeletePreselectedMomssats);
          }

          //Validering om det inte finns en förvald momssats och användaren lämnar det det tomt
          const errorNoPreselectedMomssats =
            validateUtlandskNoPreselectedMomssats(
              attestTyp,
              hasTouchedUtlandsMomsMall,
              konteringsforslag.id,
              konteringsforslag.UTL_MOMS_SATS,
              leverantorMomsmallId
            );

          if (errorNoPreselectedMomssats) {
            errors.push(errorNoPreselectedMomssats);
          }
        }
      }

      return errors;
    };
  };
